import React, { useEffect, useState } from "react";
import GlobalNav from "../components/GlobalNav";
import Footer from "../components/Footer";
import "../styles/buttons.css";
import "./RadioPage.css";

// Pulls from GET /api/radio-episodes (radio_episodes table) — the real
// backing data for this show, replacing FooterPlayer.jsx's hardcoded
// 3-item array. Distinct from GET /api/episodes, which powers Hub.jsx's
// unrelated "Inner Views" video section.
export default function RadioPage() {
  const [episodes, setEpisodes] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("/api/radio-episodes")
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setEpisodes(data.episodes || []);
        } else {
          setError(data.message || "Failed to load episodes");
        }
      })
      .catch((err) => {
        console.error("Error fetching radio episodes:", err);
        setError("Failed to load episodes");
      });
  }, []);

  return (
    <div className="radio-page">
      <GlobalNav activeHref="/radio" ctaLabel="Join the collective" />

      <div className="radio-hero">
        <div className="radio-hero-inner">
          <div className="radio-hero-eyebrow">Music Is Healing Radio</div>
          <h1 className="radio-hero-title">All episodes</h1>
          <p className="radio-hero-sub">
            Live every Wednesday at 8pm on WBCA 102.9FM, Boston's community radio
            station. Hosted by kwe.
          </p>
        </div>
      </div>

      <div className="radio-body">
        {error && <div className="radio-error">{error}</div>}

        {episodes === null && !error && (
          <div className="radio-loading">
            <div className="radio-spinner" />
            <p>Loading episodes…</p>
          </div>
        )}

        {episodes !== null && episodes.length === 0 && (
          <p className="radio-empty">No episodes posted yet — check back soon.</p>
        )}

        {episodes !== null && episodes.length > 0 && (
          <div className="radio-grid">
            {episodes.map((ep) => (
              <div className="radio-card" key={ep.id}>
                <div className="radio-card-media">
                  {ep.embed_url ? (
                    <iframe
                      src={ep.embed_url}
                      title={ep.title}
                      frameBorder="0"
                      allow="autoplay"
                    />
                  ) : ep.audio_url ? (
                    <div className="radio-card-audio-only">
                      <span>🎙</span>
                      <audio controls src={ep.audio_url} />
                    </div>
                  ) : (
                    <div className="radio-card-noart">🎙</div>
                  )}
                </div>
                <div className="radio-card-body">
                  <h2>{ep.title}</h2>
                  {ep.description && <p>{ep.description}</p>}
                  <div className="radio-card-meta">
                    {ep.published_date && (
                      <span>{new Date(ep.published_date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
                    )}
                    {ep.duration && <span>{ep.duration}</span>}
                    {ep.source_url && (
                      <a href={ep.source_url} target="_blank" rel="noopener noreferrer">Listen on WBCA →</a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
